<template>
  <div class="mt-3 mb-3">
    <div v-if="!guaranteeUserVideo" class="border rounded p-3" style="border-color: #f56c6c !important; background-color: #fef0f0;">
      <label class="font-weight-bold mb-1">Phương án bảo hành nghỉ học: <span class="text-danger">*</span></label>
      <p class="text-danger mb-1" style="font-size: 13px;">Hiện tại không tồn tại video học bù của buổi học này.</p>
      <p class="mb-0" style="font-size: 13px; color: #606266;">
        Vui lòng liên hệ với bộ phận Admin quản lý kho video và cập nhật link video
        <span
          style="color: #409eff; text-decoration: underline; cursor: pointer;"
          @click="retryCreateVideo"
        >{{ isRetrying ? 'đang tải...' : 'tại đây' }}</span>.
      </p>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-6">
          <label class="font-weight-bold mb-1">Phương án bảo hành nghỉ học: <span class="text-danger">*</span></label>
          <el-select v-model="selectedMethod" placeholder="Chọn phương án" class="w-100" @change="onMethodChange">
            <el-option
              v-for="opt in sendMethodOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
        </div>
        <div v-if="showDeadline" class="col-md-6">
          <label class="font-weight-bold mb-1">Deadline xem video</label>
          <el-date-picker
            v-model="videoDeadline"
            type="date"
            placeholder="Chọn ngày"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            class="w-100"
            @change="emitData"
          />
        </div>
      </div>

      <p v-if="selectedMethod === 2" class="mt-2 mb-0" style="font-size: 13px; color: #e6a23c;">
        Trường hợp Zalo OA lỗi, vui lòng nhập lại kết quả và copy link để gửi trực tiếp cho học viên.
      </p>

      <div v-if="showVideoLink" class="mt-3">
        <label class="font-weight-bold mb-1">Link video học bù</label>
        <div class="d-flex align-items-center">
          <el-input :value="videoUrl" readonly class="mr-2" />
          <el-button
            :type="isLinkCopied ? 'success' : 'primary'"
            :icon="isLinkCopied ? 'el-icon-check' : 'el-icon-document-copy'"
            @click="copyLink"
          >
            {{ isLinkCopied ? 'Đã sao chép' : 'Sao chép' }}
          </el-button>
        </div>
        <el-alert
          v-if="showCopyWarning"
          type="warning"
          title="Bạn chưa sao chép đường dẫn video. Vui lòng gửi cho học viên đường dẫn này."
          :closable="false"
          show-icon
          class="mt-2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: 'GuaranteeVideoSection',
  props: {
    guaranteeUserVideo: {
      type: Object,
      default: null
    },
    ticketId: {
      type: Number,
      default: null
    },
    centerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      isRetrying: false,
      sendMethodOptions: [
        { label: 'Gửi video tự động qua Zalo', value: 2 },
        { label: 'QLHV gửi trực tiếp cho học viên', value: 1 },
        { label: 'Không gửi video', value: 0 },
      ],
      selectedMethod: null,
      videoDeadline: null,
      isLinkCopied: false,
      showCopyWarning: false,
    }
  },
  computed: {
    showDeadline() {
      return this.selectedMethod === 1 || this.selectedMethod === 2;
    },
    showVideoLink() {
      return this.selectedMethod === 1;
    },
    videoUrl() {
      if (!this.guaranteeUserVideo || !this.guaranteeUserVideo.short_id) return '';
      return `${this.centerId === 295 ? 'https://video.classup.edu.vn' : 'https://video.ieltsmentor.edu.vn'}/${this.guaranteeUserVideo.short_id}`;
    }
  },
  watch: {
    guaranteeUserVideo: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (val.expired_time && !this.videoDeadline) {
          this.videoDeadline = val.expired_time.substring(0, 10);
        }
        if (val.send_method !== null && val.send_method !== undefined && this.selectedMethod === null) {
          this.selectedMethod = val.send_method;
        }
      }
    }
  },
  methods: {
    retryCreateVideo() {
      if (this.isRetrying || !this.ticketId) return;
      this.isRetrying = true;
      ApiService.post(`guarantee-videos/retry-for-ticket/${this.ticketId}`)
        .then(({ data }) => {
          if (data.error) {
            this.$notify({ type: 'warning', title: 'Thông báo', message: data.message || 'Không tìm thấy video phù hợp' });
          } else {
            this.$notify({ type: 'success', title: 'Thông báo', message: 'Tạo video học bù thành công' });
            this.$emit('video-created');
          }
        })
        .catch(() => {
          this.$notify({ type: 'warning', title: 'Thông báo', message: 'Không tìm thấy video phù hợp trong kho video' });
        })
        .finally(() => {
          this.isRetrying = false;
        });
    },
    onMethodChange() {
      this.isLinkCopied = false;
      this.showCopyWarning = false;
      this.emitData();
    },
    copyLink() {
      navigator.clipboard.writeText(this.videoUrl);
      this.isLinkCopied = true;
      this.showCopyWarning = false;
      this.emitData();
    },
    validate() {
      if (this.selectedMethod === 1 && !this.isLinkCopied) {
        this.showCopyWarning = true;
        return false;
      }
      return true;
    },
    emitData() {
      const sendMethodValue = this.selectedMethod === 0 ? null : this.selectedMethod;
      this.$emit('guarantee-data-change', {
        guaranteeAction: true,
        sendMethod: sendMethodValue,
        videoDeadline: this.videoDeadline,
        isLinkCopied: this.isLinkCopied,
        guaranteeVideoId: this.guaranteeUserVideo ? this.guaranteeUserVideo.id : null,
      });
    }
  }
}
</script>
